module.exports = __webpack_public_path__ + "img/bg.ba5142c2.png";